module.exports = __webpack_public_path__ + "img/jb.4273e622.png";